import { useRef, useState } from 'react';
import { Input, message, type InputRef } from 'antd';
import { copyText } from '../../lib/clipboard';
import { displayUrl } from '../../lib/url';

interface Props {
  /** 實際要複製的網址（百分比編碼，可直接分享）。 */
  url: string;
}

/**
 * 可複製的網址欄：平常顯示人眼可讀（解碼後中文）的網址，
 * 按「複製」時複製百分比編碼後的網址（與手機瀏覽器分享的一致，貼到 LINE 也會是可點的連結）。
 * 自動複製失敗時，改顯示實際網址並全選，讓使用者手動複製。
 */
export default function CopyUrlField({ url }: Props) {
  const ref = useRef<InputRef>(null);
  const [showRaw, setShowRaw] = useState(false);

  const onCopy = async () => {
    if (await copyText(url)) {
      message.success({
        content: (
          <span>
            已複製連結，可直接貼到 LINE／FB（與手機分享的網址相同）
            <span className="mt-1 block max-w-full truncate md:max-w-[420px] text-xs text-[#8a94a6]">{displayUrl(url)}</span>
          </span>
        ),
      });
      return;
    }
    setShowRaw(true);
    message.error('無法自動複製，請手動選取網址複製');
    // 等切換為實際網址後再全選
    setTimeout(() => ref.current?.select(), 0);
  };

  return (
    <Input.Search
      ref={ref}
      readOnly
      value={showRaw ? url : displayUrl(url)}
      enterButton="複製"
      onFocus={() => {
        if (showRaw) ref.current?.select();
      }}
      onSearch={() => void onCopy()}
    />
  );
}
